import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { XeroAccount } from './xero-account.model';
import { Store } from '@ngrx/store';
import {
  getUpdateError,
  getXeroAccount,
  initialState,
} from './xero-data.reducer';
import { filter, take } from 'rxjs/operators';

@Injectable()
export class XeroDataStore {
  xeroAccount$: Observable<XeroAccount> = this._store
    .select(getXeroAccount)
    .pipe(
      filter(
        (xeroAccount: XeroAccount) => xeroAccount !== initialState.xeroAccount
      )
    );

  updateError$: Observable<Error> = this._store.select(getUpdateError);

  constructor(private _store: Store<any>) {}

  getXeroAccount(): Observable<XeroAccount> {
    return this.xeroAccount$.pipe(take(1));
  }

  getUpdateError(): Observable<Error> {
    return this.updateError$.pipe(take(1));
  }
}
